import { render } from "./ImportCollaborators.vue?vue&type=template&id=ec9e94ee&scoped=true"
import script from "./ImportCollaborators.vue?vue&type=script&lang=js"
export * from "./ImportCollaborators.vue?vue&type=script&lang=js"

import "./ImportCollaborators.vue?vue&type=style&index=0&id=ec9e94ee&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec9e94ee"]])

export default __exports__